import { theme as baseTheme, createTheme, type PartialTheme } from '@shared/components';

const certificateTheme: PartialTheme = {
  components: {},
};

export const theme = createTheme(baseTheme, certificateTheme);
